<ng-container *ngIf="(this.expression$ | async) as expression">
  <div class="input-group min-wx-256 flex-nowrap" mesStopArrowKeyPropagation>
    <div #formula selectTextOnFocus tabindex="0"
         class="expression-formula"
         [ngClass]="cssClass" [class.disabled]="readonly"
         contenteditable [contentEditable]="!readonly"
         [(ngModel)]="expression.Formula" [title]="expression?.Comments ?? ''"
         [name]="name + '-Formula'" [attr.data-placeholder]="placeholder"
         (input)="changed.emit(expression)"
         (paste)="expression.Formula = formatFormula(expression.Formula, $event); changed.emit(expression)">
    </div>
    <div #externalFormula selectTextOnFocus tabindex="0" *ngIf="expression.ExternalFormula"
         class="expression-formula text-primary fst-italic"
         [ngClass]="cssClass" [class.disabled]="readonly"
         contenteditable [contentEditable]="!readonly"
         [(ngModel)]="expression.ExternalFormula" [title]="expression?.Comments ?? ''"
         [name]="name + '-ExternalFormula'" [attr.data-placeholder]="placeholder"
         (input)="changed.emit(expression)"
         (paste)="expression.ExternalFormula = formatFormula(expression.ExternalFormula, $event); changed.emit(expression)">
    </div>
    <button class="btn btn-outline-default btn-sm" type="button" (click)="edit()">
      <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#arrow-top-right-on-square'">
      </svg>
    </button>
  </div>
</ng-container>
